export default __webpack_public_path__ + "static/media/years_stat.1ea7663a.png";